import React, { useEffect, useState } from 'react';
import Header from '../header/header';
import './layout.scss';
import Footer from '../footer/footer';
import '../../assets/fonts/fonts.css';
// import Seo from '../seo';

const Layout = (props: any) => {
  return (
    <div>
      <Header />
      {/* <Seo title="Donate" /> */}
      <div className="main-container">
        <main>{props.children}</main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
